import { render, staticRenderFns } from "./EximBillingDetail.vue?vue&type=template&id=52ba5e2c&scoped=true&"
import script from "./EximBillingDetail.vue?vue&type=script&lang=js&"
export * from "./EximBillingDetail.vue?vue&type=script&lang=js&"
import style0 from "./EximBillingDetail.vue?vue&type=style&index=0&id=52ba5e2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ba5e2c",
  null
  
)

export default component.exports